import { Group } from '../types/groups';

enum AlgoliaObjectType {
  Area = 'area',
  Trail = 'trail',
  Alert = 'alert'
}

type GroupSearchParams = {
  indexId: string;
  groups: Group[];
  filters?: string;
};

const getTypeFilters = (types: AlgoliaObjectType[]) => {
  const filters = types.map(type => `type:${type}`).join(' OR ');
  return `(${filters})`;
};
const getGroupFilters = (groups: Group[]) => {
  const filters = groups.map(group => `group_ids:${group.id}`).join(' OR ');
  return `(${filters})`;
};

export { AlgoliaObjectType, GroupSearchParams, getTypeFilters, getGroupFilters };
